import { useTenantNavigate } from '@app-store'
import { useState } from 'react'
import { CustomButton, Tabs } from '@ui-kit'
import PatientDetails from '../../components/patient-adherence/PatientDetails'
import RiskAnalysis from '../../components/patient-adherence/RiskAnalysis'
import PersonalizedInterventions from '../../components/patient-adherence/PersonalizedInterventions'
import UpdatedAdherence from '../../components/patient-adherence/UpdatedAdherence'

const PatientAdherence = () => {
  const navigate = useTenantNavigate()

  const [welcomeCallVisible, setWelcomeCallVisible] = useState<boolean>(false)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const tabs = [
    { label: 'Patient Details', component: <PatientDetails /> },
    {
      label: 'Risk Score & Factors',
      component: <RiskAnalysis setSelectedTabIndex={setSelectedTabIndex} />,
    },
    {
      label: 'Personalized Interventions',
      component: (
        <PersonalizedInterventions
          welcomeCallVisible={welcomeCallVisible}
          setWelcomeCallVisible={setWelcomeCallVisible}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      ),
    },
    {
      label: 'Updated Adherence Plan',
      component: <UpdatedAdherence setSelectedTabIndex={setSelectedTabIndex} />,
    },
  ]

  const handleBackClick = () => {
    selectedTabIndex > 0 && setSelectedTabIndex((prevIndex) => prevIndex - 1)
    if (selectedTabIndex === 0) {
      navigate('/intake-new')
    }
    setWelcomeCallVisible(false)
  }

  const handleNextClick = () => {
    selectedTabIndex < 3 && setSelectedTabIndex((prevIndex) => prevIndex + 1)
    setWelcomeCallVisible(false)
  }

  const handleTabChangeLogic = (index: number) => {
    setSelectedTabIndex(index)
    setWelcomeCallVisible(false)
  }

  return (
    <div className="px-4">
      <div className="top flex justify-between items-center w-full">
        <span className="text-base font-semibold">Patient Adherence</span>
        <div className="buttons flex gap-3">
          {!welcomeCallVisible && (
            <CustomButton onClick={handleBackClick}>
              <span className="text-xs">Back</span>
            </CustomButton>
          )}
          {selectedTabIndex < 3 && !welcomeCallVisible && (
            <CustomButton
              color="primary"
              isFilled={true}
              onClick={handleNextClick}
              widthClass="w-fit"
            >
              <div className="flex gap-3">
                <span className="text-xs">
                  {' '}
                  {tabs[selectedTabIndex + 1].label}{' '}
                </span>{' '}
                <span>&gt;</span>
              </div>
            </CustomButton>
          )}
          {selectedTabIndex === 3 && (
            <CustomButton
              color="primary"
              isFilled={true}
              onClick={() => navigate('/intake-new')}
              widthClass="w-fit"
            >
              <div className="flex gap-2">
                <span className="text-xs">Back to Intake Queue</span>
                <span>&gt;</span>
              </div>
            </CustomButton>
          )}
        </div>
      </div>
      <div className="content flex gap-2">
        <div className="left w-full">
          <Tabs
            tabs={tabs}
            defaultActive={tabs[selectedTabIndex]}
            onChange={(_label, index) => handleTabChangeLogic(index)}
          />
        </div>
      </div>
    </div>
  )
}

export default PatientAdherence
